<template>
	<NoSsr />
</template>

<script>
import useStore from 'webmd-cms-store/src/store';

import { createApp, defineAsyncComponent, h } from 'vue';
import axios from 'axios';
import _has from 'lodash/has';
import storeUtils from 'webmd-cms-store/src/store/helpers/utils.es6';
import oauth from 'webmd-oauth/src/index.es6';
import appendSourcesWithEmbededData from 'webmd-asset-sources/src/appendSourcesWithEmbededData.es6';
import metric from 'webmd-vuejs-metrics';
import embedUtils from './common/utils';

/*
 * Vue.use(axios);
 * Vue.use(oauth);
 */

export default {
	components: {},
	props: {
		embedModules: {
			type: Object,
			required: true,
		},
		embedImageDisplay: {
			type: Boolean,
			default: true,
		},
	},
	data() {
		return {
			embedModulesConfig: {
				image: {
					moduleName: 'EmbededImage',
					modulePath: 'image/Embeded-Image.vue',
				},
				bulletedlist: {
					moduleName: 'EmbededBulletlist',
					modulePath: 'bulletlist/Embeded-Bulletlist.vue',
				},
				sharefact: {
					moduleName: 'EmbededSharefact',
					modulePath: 'sharefact/Embeded-Sharefact.vue',
				},
				pullquote: {
					moduleName: 'EmbededPullquote',
					modulePath: 'pullquote/Embeded-Pullquote.vue',
				},
				jsembed: {
					moduleName: 'EmbededJsembed',
					modulePath: 'jsembed/Embeded-Jsembed.vue',
				},

				slideshow: {
					moduleName: 'EmbededSlideshow',
					modulePath: 'slideshow/Embeded-Slideshow.vue',
				},
				video: {
					moduleName: 'EmbededVideo',
					modulePath: 'video/Embeded-Video.vue',
				},
				quiz: {
					moduleName: 'EmbededQuiz',
					modulePath: 'quiz/Embeded-Quiz.vue',
				},
			},
			embedModulesData: this.embedModules,
			apiNeededComponents: ['slideshow', 'quiz'],
			apimoduleIds: [],
			embedModuleData: {},
			s_packageType: null,
			pageType: null,
		};
	},
	computed: {
	},
	methods: {
		getComponentName(compType) {
			let moduleName = '';
			if (compType && this.embedModulesConfig[compType]) {
				moduleName = this.embedModulesConfig[compType].moduleName;
			}
			return moduleName;
		},
		getComponentPath(compType) {
			let modulePath = '';
			if (compType && this.embedModulesConfig[compType]) {
				modulePath = this.embedModulesConfig[compType].modulePath;
			}
			return modulePath;
		},
		getEmbedTagConfig(embedTagData) {
			let embedConfigObj = {};
			embedConfigObj = embedUtils.getEmbedTagProps(embedTagData);
			return embedConfigObj;
		},
		getPagePackageType() {
			/* eslint-disable max-len */
			if (this.store && this.store.pagedata && this.store.pagedata.omniture && this.store.pagedata.omniture.s_package_type) {
				return this.store.pagedata.omniture.s_package_type;
			}
			return '';
		},
		getPageType() {
			let pageType = '';
			if (this.store && this.store.cms.allModules && this.store.cms.isInteractivePage) {
				pageType = 'interactive';
			}
			return pageType;
		},
		replaceEmbedTag(embedTagVal) {
			const linkPattern = '(link_friendlyurl=)';
			/* eslint-disable no-param-reassign */
			embedTagVal = embedTagVal.replace(new RegExp(linkPattern, 'gi'), 'href=');
			return embedTagVal;
		},
		renderEmbedComponent(embedCompData) {
			const self = this;
			if (!embedCompData) {
				return;
			}

			if ((embedCompData.type === 'image') && !this.embedImageDisplay) {
				return;
			}

			const targetEle = document.getElementById(embedCompData.id);
			const componentName = this.getComponentName(embedCompData.type);
			if (componentName === 'EmbededSharefact' && this.getPagePackageType() === 'Treatment Seeker') {
				embedCompData.isTitleSharebar = true;
			}
			const EmbedComponent = this.$options.components[componentName];
			/* eslint-disable no-underscore-dangle */
			const chronicid = embedCompData.embedConfig._chronic_id;

			if (componentName && EmbedComponent && targetEle) {
				if (embedCompData.type != 'video') {
					targetEle.innerHTML = '';
				}
				const mountingEle = document.createElement('div');
				mountingEle.className = 'ia-module-mount';
				targetEle.appendChild(mountingEle);

				/* eslint-disable no-param-reassign */
				embedCompData.content = this.replaceEmbedTag(embedCompData.content);

				/* eslint-disable no-param-reassign */
				embedCompData.pagePackageType = this.s_packageType;

				/* eslint-disable no-param-reassign */
				embedCompData.moduleData = this.embedModuleData[chronicid];

				if (embedCompData.type == 'video') {
					let title = embedCompData.content.match(/<title>(.*?)<\/title>/);
					if (title && title.length == 2) {
						title = title[1];
					}
					let description = embedCompData.content.match(/<wbmd_c_vid_citations>(.*?)<\/wbmd_c_vid_citations>/);
					if (description && description.length == 2) {
						description = description[1];
					}

					appendSourcesWithEmbededData(embedCompData.type, title, description);

					// Set the Video title position default to bottom.
					embedCompData.titlePosition = embedCompData.titlePosition || 'bottom';
				} else if (embedCompData.type == 'slideshow') {
					appendSourcesWithEmbededData(
						embedCompData.type,
						embedCompData.moduleData?.content_section.cons_slideshow.title,
						embedCompData.moduleData?.content_section.cons_slideshow.citations['#cdata-section'],
					);
				} else if (embedCompData.type == 'quiz') {
					appendSourcesWithEmbededData(
						embedCompData.type,
						embedCompData.moduleData?.content_section.quiz.quiztitle,
						embedCompData.moduleData?.content_section.quiz.citations['#cdata-section'],
					);
				}

				createApp({ render: () => h(EmbedComponent) }, { 'embed-data-props': embedCompData })
					.use(oauth)
					.use(metric)
					.use(self.$pinia)
					.mount(mountingEle);
			}
		},
		fetchEmbedModulesData() {
			let idsStr = '';
			this.apimoduleIds = embedUtils.removeDuplicatesFromArray(this.apimoduleIds);
			const oauthHeaders = oauth.generate();

			this.apimoduleIds.forEach((val, index) => {
				idsStr += `${index ? ' ' : ''}DCTM_${val}`;
			});

			const params = {
				id: idsStr,
			};
			let apiUrl = `${storeUtils.getEnvironment().servicedomain}/search/2/api/embeded_module_api`;
			if (this.isBlog) {
				apiUrl = apiUrl.replace('www', 'blogs');
			}
			return axios.get(apiUrl, {
				params,
				headers: oauthHeaders,
			});
		},
		isBlog() {
			let checkBlog = false;
			if (_has(this.store.pagedata, 'omniture.center_prefix')) {
				checkBlog = this.store.pagedata.omniture.center_prefix.toLowerCase() === 'blogs';
			}
			return checkBlog;
		},

		customiseEmbedObj() {
			Object.keys(this.embedModulesData).forEach((index) => {
				let embedConfig = {};
				const embedModObj = this.embedModulesData[index];

				embedConfig = this.getEmbedTagConfig(embedModObj.content);
				if (embedConfig) {
					embedModObj.embedConfig = embedConfig;
					embedModObj.modSuppress = embedUtils.suppressEmbedModule(embedConfig, this.s_packageType);
					/* eslint-disable no-underscore-dangle */
					embedModObj.chronicId = embedConfig._chronic_id;
					embedModObj.pageType = this.pageType;

					if (embedConfig.type === 'video' || embedConfig.type === 'slideshow') {
						embedModObj.store = this.$pinia;
					}
					if (this.apiNeededComponents.indexOf(embedConfig.type) !== -1) {
						/* eslint-disable no-underscore-dangle */
						this.apimoduleIds.push(embedConfig._chronic_id);
					}
				}
				embedModObj.isSiteFronts = this.isSiteFronts;
				this.embedModulesData[index] = embedModObj;
			});
		},
		dynamicImportComponents() {
			Object.keys(this.embedModulesData).forEach((emdedKey) => {
				const moduleType = this.embedModulesData[emdedKey].type;
				const suppressed = this.embedModulesData[emdedKey].modSuppress;
				if (moduleType && !suppressed) {
					const componentName = this.getComponentName(moduleType);
					const componentPath = this.getComponentPath(moduleType);

					if (componentName && componentPath) {
						if (!this.$options.components[componentName]) {
							/* eslint template-curly-spacing: "error" */
							this.$options.components[componentName] = defineAsyncComponent(() => import(/* webpackChunkName: "load-dynamic" */`./${componentPath}`));
						}
					}
				}
			});
		},
	},
	created() {
		this.store = useStore(this.$pinia);
		this.customiseEmbedObj();
		this.dynamicImportComponents();
		if (this.apimoduleIds && this.apimoduleIds.length) {
			this.apiModulesPromise = this.fetchEmbedModulesData();
		}

		this.s_packageType = this.getPagePackageType();
		this.pageType = this.getPageType();
	},
	mounted() {
		Object.keys(this.embedModulesData).forEach((emdedKey) => {
			const currentEmbedData = this.embedModulesData[emdedKey];

			/**
			 * Rendering Embeded components by Excluding api required embeded modules
			 */
			/* eslint-disable max-len */
			if (!currentEmbedData.modSuppress && this.apiNeededComponents.indexOf(currentEmbedData.type) === -1) {
				this.renderEmbedComponent(currentEmbedData);
			}
		});

		/**
		 * Rendering only Api Required Embed Components after getting api response
		 */
		if (this.apimoduleIds && this.apimoduleIds.length) {
			this.apiModulesPromise.then((res) => {
				/* eslint-disable max-len */
				const response = (res && res.status === 200 && res.data && res.data.data && Array.isArray(res.data.data)) ? res.data.data : null;
				if (response && response.length) {
					response.forEach((val) => {
						const chronicId = val.id;
						this.embedModuleData[chronicId] = val;
					});
				}

				Object.keys(this.embedModulesData).forEach((emdedKey) => {
					const currentEmbedData = this.embedModulesData[emdedKey];

					// Exclude rerendering static components by excluding them based on type
					/* eslint-disable max-len */
					if (!currentEmbedData.modSuppress && this.apiNeededComponents.indexOf(currentEmbedData.type) !== -1) {
						this.renderEmbedComponent(currentEmbedData);
					}
				});
			});
		}
	},
};
</script>

<style lang="scss">
/* global styles */
@import "./common/embedstyles.scss";
</style>
